import api from "./api";

export const getExecutiveDashboardData = async () => {
    const [shipmentsRes, ordersRes, iotRes, blockchainRes] =
        await Promise.allSettled([
            api.get("/Shipment/all"),
            api.get("/orders/active"),
            api.get("/IoTDevice"),
            api.get("/BlockchainLog"),
        ]);

    const shipments =
        shipmentsRes.status === "fulfilled" && Array.isArray(shipmentsRes.value.data)
            ? shipmentsRes.value.data
            : [];

    const orders =
        ordersRes.status === "fulfilled" && Array.isArray(ordersRes.value.data)
            ? ordersRes.value.data
            : [];

    const devices =
        iotRes.status === "fulfilled" && Array.isArray(iotRes.value.data)
            ? iotRes.value.data
            : [];

    const blockchainLogs =
        blockchainRes.status === "fulfilled" && Array.isArray(blockchainRes.value.data)
            ? blockchainRes.value.data
            : [];

    const onlineDevices = devices.filter((d) => {
        if (!d.lastUpdated) return false;
        return Date.now() - new Date(d.lastUpdated).getTime() < 2 * 60 * 1000;
    }).length;

    const deliveredToday = shipments.filter((s) => {
        const status = (s.status || s.shipmentStatus || "").toLowerCase();
        const date = s.deliveredAt || s.updatedAt || s.createdAt;

        if (!date) return false;

        const d = new Date(date);
        const now = new Date();

        return (
            status.includes("delivered") &&
            d.getFullYear() === now.getFullYear() &&
            d.getMonth() === now.getMonth() &&
            d.getDate() === now.getDate()
        );
    }).length;

    return {
        activeShipments: shipments.length,
        activeOrders: orders.length,
        deliveredToday,
        iotDevices: devices.length,
        onlineDevices,
        blockchainEvents: blockchainLogs.length,
        averageTrustScore: 94,
        aiRisk: 6,
        revenueToday: 0,
    };
};

export default {
    getExecutiveDashboardData,
};